export default __webpack_public_path__ + "static/area-kids-cercada-712338e24dfe4543a8abd5e66d26e948.webp";